const getStatusMember = function (groups, current_user_id) {
  const membersInGroupsProto = groups.map((group) => {
    const members = group?.members || [];
    const user_id = members.map((member) => {
      return member;
    });
    return user_id;
  });
  const membersInGroups = membersInGroupsProto.flat();
  const statusUser = membersInGroups.filter(
    (member) => member?.user?._id === current_user_id
  )[0]?.status;

  let status_user_final = "guest";
  if (!!statusUser) {
    status_user_final = statusUser;
  }
  return status_user_final;
};

export default getStatusMember;
